/**
 * @param props
 */

export default (props) => {
    return {
        strippers: [],
        async mounted() {
            const response = await fetch('/service/dating.json?genre=' + this.service.genre );
            const json = await response.json();
            this.strippers = json.payload.models;
        },
    }
};